import React from "react";
import BranchCostConfigListForm from './list/BranchCostConfigListForm';
import CreateBranchCostConfigForm from './create/CreateBranchCostConfigForm'

const BranchCostConfigView = ({ displayList }) => {
  return displayList ? (
    <BranchCostConfigListForm />
  ) : (
    <CreateBranchCostConfigForm />
  );
};

export default BranchCostConfigView;
